<div class="d-flex align-items-center justify-content-between mb-3">
  <h1 class="mb-0">Conference Applications</h1>
  <button type="button" class="btn btn-secondary btn-thin" (click)="load()">
    <i class="fas fa-sync-alt"></i> Refresh
  </button>
</div>

<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-md-3">
        <label for="conference-status-filter"><b>Status</b></label>
        <select id="conference-status-filter" class="form-control" [(ngModel)]="statusFilter">
          <option [ngValue]="null">All statuses</option>
          <option *ngFor="let status of statuses" [ngValue]="status.value">{{status.label}}</option>
        </select>
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-name-filter"><b>Conference</b></label>
        <input id="conference-name-filter" class="form-control" [(ngModel)]="conferenceFilter" />
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-role-filter"><b>Role Category</b></label>
        <input id="conference-role-filter" class="form-control" [(ngModel)]="roleFilter" />
      </div>
      <div class="col-12 col-md-3 mt-2 mt-md-0">
        <label for="conference-date-filter"><b>Submitted Date</b></label>
        <input id="conference-date-filter" type="date" class="form-control" [(ngModel)]="submittedDateFilter" />
      </div>
    </div>

    <div class="text-center p-4" *ngIf="loading">
      <i class="material-icons rotate text-muted">loop</i>
    </div>

    <div class="table-responsive mt-3" *ngIf="!loading">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Conference</th>
            <th>Level</th>
            <th>Role Category</th>
            <th>Submitted</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let application of filteredApplications">
            <td>{{application.employeeName}}</td>
            <td>{{application.conferenceTitle}}</td>
            <td>{{application.levelLabel}}</td>
            <td>{{application.eligibilitySnapshot?.roleCategoryName || 'Not assigned'}}</td>
            <td>{{application.submittedDate | date:'shortDate'}}</td>
            <td>
              {{application.statusLabel}}
              <span class="badge badge-warning ml-1" *ngIf="application.isException">Exception</span>
            </td>
            <td class="text-right">
              <button type="button" class="btn btn-primary btn-thin" (click)="openApplication(application)">
                Review
              </button>
            </td>
          </tr>
          <tr *ngIf="!filteredApplications.length">
            <td colspan="7" class="text-muted">No conference applications match these filters.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<p-dialog header="Conference Application Review" [modal]="true" [style]="{width: '85vw'}"
          [(visible)]="showDetail">
  <ng-container *ngIf="selectedApplication">
    <div class="row">
      <div class="col-12 col-md-6">
        <h2>{{selectedApplication.conferenceTitle}}</h2>
        <div><b>Employee:</b> {{selectedApplication.employeeName}}</div>
        <div><b>Location:</b> {{selectedApplication.conferenceLocation || '-'}}</div>
        <div><b>Dates:</b> {{selectedApplication.conferenceStartDate | date:'shortDate'}} -
          {{selectedApplication.conferenceEndDate | date:'shortDate'}}</div>
        <div><b>Level:</b> {{selectedApplication.levelLabel}}</div>
        <div><b>Status:</b> {{selectedApplication.statusLabel}}</div>
      </div>
      <div class="col-12 col-md-6 mt-3 mt-md-0">
        <h3>Hours</h3>
        <div><b>Accrued:</b> {{selectedApplication.eligibilitySnapshot?.accruedHours | number:'1.2-2'}}</div>
        <div><b>Available at submission:</b> {{selectedApplication.eligibilitySnapshot?.availableHours | number:'1.2-2'}}</div>
        <div><b>Configured requirement:</b> {{selectedApplication.plannedHours | number:'1.2-2'}}</div>
        <div><b>Reserved:</b> {{selectedApplication.reservedHours | number:'1.2-2'}}</div>
      </div>
    </div>

    <div class="alert alert-warning mt-3" *ngIf="selectedApplication.isException">
      <b>Exception review required</b>
      <ul class="mb-0">
        <li *ngFor="let reason of selectedApplication.exceptionReasons">{{reason}}</li>
      </ul>
    </div>

    <h3 class="mt-4">Eligibility Snapshot</h3>
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Level</th>
            <th>Required Hours</th>
            <th>Result</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let level of selectedApplication.eligibilitySnapshot?.levelResults">
            <td>{{level.levelLabel}}</td>
            <td>{{level.requiredHours | number:'1.2-2'}}</td>
            <td>{{level.eligible ? 'Eligible' : 'Exception'}}</td>
            <td>{{level.reasons.join('; ') || 'All requirements met'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 class="mt-4" *ngIf="selectedApplication.answers.length">Application Answers</h3>
    <div class="border-top pt-2 mt-2" *ngFor="let answer of selectedApplication.answers">
      <b>{{answer.questionPrompt}}</b>
      <div *ngIf="!answer.hasFile">{{answer.displayAnswer || '-'}}</div>
      <a *ngIf="answer.hasFile" [href]="fileUrl(answer.id)" target="_blank" rel="noopener">
        <i class="fas fa-paperclip"></i> {{answer.fileName}}
      </a>
    </div>

    <h3 class="mt-4">Review History</h3>
    <div class="border-top pt-2 mt-2" *ngFor="let history of selectedApplication.statusHistory">
      <b>{{history.statusLabel}}</b> by {{history.changedByName}} on {{history.changedDate | date:'short'}}
      <span class="badge badge-warning ml-1" *ngIf="history.isOverride">Override</span>
      <div *ngIf="history.notes">{{history.notes}}</div>
    </div>

    <div class="border-top mt-4 pt-3" *ngIf="reviewActions.length">
      <h3>Review Action</h3>
      <select class="form-control" [(ngModel)]="selectedStatusID">
        <option [ngValue]="null">Select an action</option>
        <option *ngFor="let action of reviewActions" [ngValue]="action.statusID">{{action.label}}</option>
      </select>
      <label class="mt-3"><b>Reviewer Notes</b></label>
      <textarea class="form-control" rows="4" [(ngModel)]="notes"></textarea>
      <label class="d-block mt-3">
        <input type="checkbox" [(ngModel)]="isOverride" />
        Approve or advance as a policy exception
      </label>
      <button type="button" class="btn btn-primary mt-2" [disabled]="saving" (click)="submitReview()">
        Save Review
      </button>
    </div>
  </ng-container>
</p-dialog>
